import {
  CustomMarkerBuilderI,
  GeneratePointI,
  MapState,
  ProcessMapSearchResponseStrategy,
} from 'src/app/interfaces/map.interface';
import { CustomMarker } from 'src/app/models/custom-marker.model';
import { Community, FullUser, Project } from 'src/app/swagger-api';
import { SearchResult } from 'src/app/swagger-api/model/searchResult';
import { CustomMarkerBuilderFactory } from '../builders/marker-creator.method';
import { getSearchNonAggregationDecoratedResponse, isUserEntityKind } from '../decorators/decorators.helpers';

export class NonAggregatedItemsProcessor implements ProcessMapSearchResponseStrategy {
  public constructor(
    private response: SearchResult[],
    private state: MapState,
  ) {}

  public getMarkers(): CustomMarker[] {
    return getSearchNonAggregationDecoratedResponse(this.response, this.state).map((result: SearchResult) => {
      const builder: CustomMarkerBuilderI = this.selectBuilder(result);
      builder.setMarkerId(result.item);
      this.setCoords(result, builder);
      builder.setCustomMarkerData(result.item as object);
      builder.setIcon((result.item as GeneratePointI)['count']);
      return builder.buildMarker();
    });
  }

  private setCoords(result: SearchResult, builder: CustomMarkerBuilderI): void {
    if (isUserEntityKind(result)) {
      const fullUser: FullUser = result.item as FullUser;
      builder.setCoords(fullUser.profile.location.center.lat, fullUser.profile.location.center.lon);
    } else {
      const locatableEntity: Project | Community = result.item as Project | Community;
      builder.setCoords(locatableEntity.location.center.lat, locatableEntity.location.center.lon);
    }
  }

  private selectBuilder(result: SearchResult): CustomMarkerBuilderI {
    let type: string = result.entity_kind;
    if (isUserEntityKind(result)) {
      type = (result.item as FullUser).user_roles[0];
    }

    return CustomMarkerBuilderFactory.getBuilder(type);
  }
}
